/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteProjectSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type DeleteProjectRequest = {
  /**
   * The id of the project to delete
   */
  id: string;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type DeleteProjectSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteProjectSecurity$outboundSchema: z.ZodMiniType<
  DeleteProjectSecurity$Outbound,
  DeleteProjectSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteProjectSecurityToJSON(
  deleteProjectSecurity: DeleteProjectSecurity,
): string {
  return JSON.stringify(
    DeleteProjectSecurity$outboundSchema.parse(deleteProjectSecurity),
  );
}

/** @internal */
export type DeleteProjectRequest$Outbound = {
  id: string;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteProjectRequest$outboundSchema: z.ZodMiniType<
  DeleteProjectRequest$Outbound,
  DeleteProjectRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
    });
  }),
);

export function deleteProjectRequestToJSON(
  deleteProjectRequest: DeleteProjectRequest,
): string {
  return JSON.stringify(
    DeleteProjectRequest$outboundSchema.parse(deleteProjectRequest),
  );
}
